if (!customElements.get('redefine-occasions')) {
 customElements.define('redefine-occasions', class extends HTMLElement {
  connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
  init() {
   if (!this.isConnected || this.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
   this.classList.add('is-ready');
   this.observer = new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
     entry.target.classList.add('is-in');
     this.observer.unobserve(entry.target);
    }
   }, {rootMargin: '0px 0px -10% 0px'});
   this.querySelectorAll('[data-reveal]').forEach(el => this.observer.observe(el));
  }
  disconnectedCallback() {
   cancelAnimationFrame(this.frame);
   this.observer?.disconnect();
   this.classList.remove('is-ready');
   this.querySelectorAll('.is-in').forEach(el => el.classList.remove('is-in'));
  }
 });
}
